import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isDropdown, setDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const _token = sessionStorage.getItem('_token')

  const navigate = useNavigate()

  const handleClickOutside = (event) => {
    if (
      isDropdown &&
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdown]);

  const handleDropdown = () => {
    setDropdown(!isDropdown);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const Logout = () => {
    sessionStorage.removeItem('_token');
    toast.success('Logout Successfull')
    setTimeout(() => {
      navigate('/Login')
    }, 600)
  }

  return (
    <div className="w-full sticky top-0 z-50 py-5 font-montserrat px-5 md:px-10 text-white flex">
      <div className="md:w-[25%] w-full flex justify-between items-center ">
        <div className=" flex items-center gap-2">
          <div>
            <img src="../assets/Logo/logo.svg" className="w-14" />
          </div>
          <div>
            <p className="font-bold text-lg font-Artemus ">Stabilix</p>
          </div>
        </div>
        <div
          onClick={handleDropdown}
          ref={buttonRef}
          className=" cursor-pointer md:hidden block "
        >
          <i class="fa-solid fa-bars"></i>
        </div>
      </div>

      <div className=" w-[85%] md:block hidden  ">
        <div className=" flex justify-end items-center gap-10 ">
          <nav className=" flex gap-10 font-semibold text-white/75 text-sm ">
            <a className="cursor-pointer" onClick={() => scrollToSection('about')}>About</a>
            <a className="cursor-pointer" onClick={() => scrollToSection('collection')}>Collection</a>
            <a className="cursor-pointer" onClick={() => scrollToSection('faq')}>FAQs</a>
            <a className="cursor-pointer" onClick={() => navigate('/login')}>Login</a>
            {_token ? (
              <a className="cursor-pointer" onClick={() => Logout()}>Logout</a> 
            ) : ''}
          </nav>

          <div className="">
            <div className="flex items-center gap-2">
              <div>
                <img src="../assets/Socialmedia/Twitter.svg" />
              </div>
              <div>
                <img src="../assets/Socialmedia/Discord.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" md:hidden block ">
        {isDropdown && (
          <div
            className="absolute top-14 right-3 z-30  border shadow-md rounded-lg p-3 font-semibold bg-black"
            data-aos="flip-right"
            data-aos-duration="1000"
            ref={dropdownRef}
          >
            <nav className="flex flex-col gap-1.5 text-center ">
              <a className="cursor-pointer" onClick={() => scrollToSection('about')}>About</a>
              <a className="cursor-pointer" onClick={() => scrollToSection('collection')}>Collection</a>
              <a className="cursor-pointer" onClick={() => scrollToSection('faq')}>FAQs</a>
              <a className="cursor-pointer" onClick={() => navigate('/login')}>Login</a>
              {_token ? (
                <a className="cursor-pointer" onClick={() => scrollToSection('faq')}>Logout</a>
              ) : ""}

            </nav>
            <div className="flex justify-center items-center mt-3 gap-2">
              <div>
                <img src="../assets/Socialmedia/Twitter.svg" />
              </div>
              <div>
                <img src="../assets/Socialmedia/Discord.svg" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
